import "../Footer/Footer.css"
export function Footer(){
    return (
        <div className="footer">
               <div className="footer-container">
            <div>
                General
                <ul>
                    <li  className="list-body-item padding-sm">
                        <span className="list-body-item">FIND A STORE</span></li>
                    <li  className="list-body-item padding-sm">
                        <span className="list-body-item">BECOME A MEMBER</span></li>
                    <li  className="list-body-item padding-sm">
                        <span className="list-body-item">SIGN UP FOR EMAIL</span></li>
                    <li  className="list-body-item padding-sm">
                        <span className="list-body-item">STUDENT DISCOUNTS</span></li>
                
                </ul>
            </div>
            <div>
                Help & Support
                <ul>
                    <li  className="list-body-item padding-sm">
                        <span className="list-body-item">Order Status</span></li>
                    <li  className="list-body-item padding-sm">
                        <span className="list-body-item">Returns & Exchange</span></li>
                    <li  className="list-body-item padding-sm">
                        <span className="list-body-item">Shipping</span></li>
                    <li  className="list-body-item padding-sm">
                        <span className="list-body-item">Help</span></li>
                    <li  className="list-body-item padding-sm">
                        <span className="list-body-item">Customer Service</span></li>
                    <li  className="list-body-item padding-sm">
                        <span className="list-body-item">Contact Us Inquiries</span></li>
                
                </ul>
            </div>
            <div>
                Company Info
                <ul>
                    <li  className="list-body-item padding-sm">
                        <span className="list-body-item">About US</span></li>
                    <li  className="list-body-item padding-sm">
                        <span className="list-body-item">News</span></li>
                    <li  className="list-body-item padding-sm">
                        <span className="list-body-item">Investors</span></li>
                    <li  className="list-body-item padding-sm">
                        <span className="list-body-item">Careers</span></li>
                    <li  className="list-body-item padding-sm">
                        <span className="list-body-item">Press</span></li>
                    <li  className="list-body-item padding-sm">
                        <span className="list-body-item">Entity Details</span></li>
                
                </ul>
            </div>
            <div>
                Collections
                <ul>
                    <li  className="list-body-item padding-sm">
                        <span className="list-body-item">Sports Running</span></li>
                    <li  className="list-body-item padding-sm">
                        <span className="list-body-item">Women</span></li>
                    <li  className="list-body-item padding-sm">
                        <span className="list-body-item">Gym/Training</span></li>
                    <li  className="list-body-item padding-sm">
                        <span className="list-body-item">Football</span></li>
                    <li  className="list-body-item padding-sm">
                        <span className="list-body-item">BasketBall</span></li>
                    <li  className="list-body-item padding-sm">
                        <span className="list-body-item">Swimming</span></li>
                
                </ul>
            </div>
        </div>
        <div className="footer-base">
            <div>India, © 2022 Feetz, Inc. All Rights Reserved</div>
            <ul className="footer-base-content">
                <li  className="list-body-item padding-sm">
                    <span className="list-body-item">Privacy Policy</span></li>
                <li  className="list-body-item padding-sm">
                    <span className="list-body-item">Terms Of use</span></li>
                <li  className="list-body-item padding-sm">
                    <span className="list-body-item">Cookies</span></li>
                <li  className="list-body-item padding-sm">
                    <span className="list-body-item">Guides</span></li>
            </ul>
        </div>
        </div>
    )
}